/**
 * The colour choices for labels and To do boards (27 Oct 2026), Trello's
 * palette. Label colours are the same in light and dark mode; board
 * backgrounds are soft tints, darker at night (--board-<name> in tokens.css).
 */

export const COLOR_NAMES = ['green', 'yellow', 'orange', 'red', 'purple', 'blue', 'sky', 'lime', 'pink', 'grey'] as const
export type ColorName = (typeof COLOR_NAMES)[number]

export const LABEL_HEX: Record<ColorName, string> = {
  green: '#4bce97',
  yellow: '#f5cd47',
  orange: '#fea362',
  red: '#f87168',
  purple: '#9f8fef',
  blue: '#579dff',
  sky: '#6cc3e0',
  lime: '#94c748',
  pink: '#e774bb',
  grey: '#8590a2',
}

export const COLOR_LABEL: Record<ColorName, string> = {
  green: 'Green',
  yellow: 'Yellow',
  orange: 'Orange',
  red: 'Red',
  purple: 'Purple',
  blue: 'Blue',
  sky: 'Sky',
  lime: 'Lime',
  pink: 'Pink',
  grey: 'Grey',
}

export function isColorName(value: unknown): value is ColorName {
  return typeof value === 'string' && (COLOR_NAMES as readonly string[]).includes(value)
}

/** A board's background: its tint, or the default list grey. */
export function boardBackground(color: string | null | undefined): string {
  return isColorName(color) ? `var(--board-${color})` : 'var(--color-paper)'
}
